// extracted by mini-css-extract-plugin
module.exports = {"inputSearch":"PixTaxonomySelect_inputSearch__204GT","cascader":"PixTaxonomySelect_cascader__2F28i"};